import React, { ChangeEvent } from 'react';

import { MenuItem } from '@material-ui/core';
import { Box } from '@mui/material';

import TranslationHelper from '../../../../helpers/TranslationHelper';
import { useToolkitDispatch } from '../../../../hooks';

import {
    selectWorkflow,
    setStatusesFilter,
    toggleAssignedToMe,
} from '../../state';
import {
    useFilters,
    useSelectedWorkflow,
    useWorkflows,
} from '../../state/index.hooks';

import SelectField from '../../../../components/SelectField';
import CustomCheckbox from '../../../../components/common/CustomCheckbox';
import MultiSelectCheckboxes from '../../../../components/MultiSelectCheckboxes/MultiSelectCheckboxes';
import { IWorkflowStatus } from '../../types';

interface IOwnProps {
    availableStatuses: IWorkflowStatus[] | undefined;
}
const TicketGridFilters = ({ availableStatuses }: IOwnProps) => {
    const selectedWorkflow = useSelectedWorkflow();
    const workflows = useWorkflows();
    const toolkitDispatch = useToolkitDispatch();
    const { assignedToMe, statuses } = useFilters();
    const renderOptions = () => {
        return workflows?.map((wf) => {
            return (
                <MenuItem key={wf.name} value={wf.name}>
                    {TranslationHelper.translate(wf.label, 'wx')}
                </MenuItem>
            );
        });
    };
    const handleChangeWorkflow = (e: ChangeEvent<HTMLInputElement>) => {
        toolkitDispatch(setStatusesFilter([]));
        toolkitDispatch(selectWorkflow(e.target.value));
    };

    const handleAssignedToMeChange = () => {
        toolkitDispatch(toggleAssignedToMe());
    };

    const handleStatusSelection = (
        selected: { id: string; label: string }[]
    ) => {
        toolkitDispatch(setStatusesFilter(selected));
    };
    const mappedStatuses = availableStatuses?.map((status) => {
        return {
            id: status.name,
            label: status.label,
        };
    });

    return (
        <>
            <Box
                sx={{
                    minWidth: '150px',
                    mr: 1,
                }}
            >
                <SelectField
                    name="selectedWorkflow"
                    label="Category"
                    value={String(selectedWorkflow || '')}
                    renderOptions={renderOptions}
                    handleChange={handleChangeWorkflow}
                />
            </Box>
            <CustomCheckbox
                checked={assignedToMe}
                onChange={handleAssignedToMeChange}
                label="assignedToMe"
            />
            {availableStatuses?.length && (
                <MultiSelectCheckboxes
                    label="Filter by status"
                    options={mappedStatuses || []}
                    selected={statuses}
                    onChange={handleStatusSelection}
                />
            )}
        </>
    );
};

export default TicketGridFilters;
